// When a tab tells its page that this device was signed out of a profile's public ledger account (#24 phase 3). The
// sign-out can reach a tab several ways (its plDevice row's live watch, a re-check, a signature the server refused, another
// tab removing the key from localStorage), in any order, and some find localStorage already emptied by another. Each tab
// keeps its own note of which profiles have a wallet it hasn't yet announced the loss of: a wallet restored or added for
// a profile arms it, and the first path to report the sign-out takes it, so it is announced exactly once.

export class DeviceSignOutNotice {
  private readonly __armed = new Set<string>();

  /** A wallet was restored or added for the profile in this tab: its next sign-out is announced. */
  arm(profileId: string) {
    this.__armed.add(profileId);
  }

  /**
   * The profile's wallet was signed out. True for the first report since it was last armed, which announces it; false for
   * every later report, and for a profile this tab never held a wallet for.
   */
  take(profileId: string): boolean {
    return this.__armed.delete(profileId);
  }
}
